import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import store from '@/store';
import { SaldoDetalhadoInterface } from '@/shared/models/usuario/saldo-detalhado.interface';
import { instanciaAxios } from './base.service';

const pathBase = 'usuario-externo';

export default class SaldoDetalhadoService {
  async getSaldoDetalhado(cpf: string): Promise<any> {
    return await instanciaAxios
      .get(`${pathBase}/saldo-detalhado/${cpf}`)
      .then((response: any) => {
        const lista: Array<SaldoDetalhadoInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }
}
